// @flow

import styled from 'styled-components';
import type { AtomProps as Props } from '../types';
import type { Theme } from '../../../../types';

const StyledBox = styled<any, Theme, Props>('div')`
  font-size: 1.125rem;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  border: solid 0.25em ${props => props.theme.form.radio.borderColor};
  box-shadow: 0 0 0 1px ${props => props.theme.form.radio.boxShadowColor};
  padding: 0.1em;
  box-sizing: border-box;
  margin-right: 0.7em;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => ((props.checked || false) ? props.theme.form.radio.selected : props.theme.form.radio.backgroundColor)};
`;

export default StyledBox;
